/**
 * @fileoverview PUT handler for the "/companies/:company_id/anonymous_aggregated_ai_training_kill_switch" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdAnonymousAggregatedAiTrainingOptOutCacheKeys } from "./constants";
import type {
  PutCompanyAnonymousAggregatedAiTrainingOptOutProps,
  CompanyAnonymousAggregatedAiTrainingOptOutResult,
} from "./types";

export const putCompanyAnonymousAggregatedAiTrainingOptOut = reactQueryMutationAdapter(
  companiesCompanyIdAnonymousAggregatedAiTrainingOptOutCacheKeys,
  ({
    companyId,
    anonymousAggregatedAiTrainingKillSwitch,
  }: PutCompanyAnonymousAggregatedAiTrainingOptOutProps): Promise<CompanyAnonymousAggregatedAiTrainingOptOutResult> => {
    return fetch(
      `/companies/${companyId}/anonymous_aggregated_ai_training_kill_switch`,
      "PUT",
      {
        company_id: companyId,
        anonymous_aggregated_ai_training_kill_switch: anonymousAggregatedAiTrainingKillSwitch,
      },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
